import { FindingType_Enumerated, FindingType_Numeric } from '@app/advisor-shared';
import { ModuleFE_Advisor_Variable } from '@app/advisor-frontend';
import { variableType_AttributeInstance } from '@app/hcs-shared';
import { exists } from '@nu-art/ts-common';
const getAttributes = (variableId) => ModuleFE_Advisor_Variable.cache.filter(v => {
    return v.type === variableType_AttributeInstance
        && v.parents.variableId === variableId;
});
//Conversion - AttributeInstance => ProcessedRawFindingAttribute
function convert_Attribute_ProcessedAttribute(att, parentFinding) {
    return {
        variableId: att._id,
        type: 'enumerated',
        valueIds: parentFinding.attributes?.find(rtAtt => rtAtt.variableId === att._id)?.valueIds,
    };
}
//Conversion - Finding => FindingToUpdate
function convert_Finding_FindingToUpdate(f) {
    let findingToUpdate;
    switch (f?.type) {
        case FindingType_Numeric: {
            const processed = {
                variableId: f.variableId,
                type: f.type,
                value: f.value,
                isChiefComplaint: f.isChiefComplaint,
                measurementUnitId: f.measurementUnitId,
            };
            findingToUpdate = {
                ...processed,
                findingId: f._id,
            };
            break;
        }
        case FindingType_Enumerated: {
            const processed = {
                variableId: f.variableId,
                type: f.type,
                valueIds: f.valueIds,
                isChiefComplaint: f.isChiefComplaint,
            };
            findingToUpdate = {
                ...processed,
                findingId: f._id,
            };
            //Generate Attributes
            const attributeInstances = getAttributes(f.variableId);
            if (attributeInstances.length)
                findingToUpdate.attributes = attributeInstances.map(att => convert_Attribute_ProcessedAttribute(att, f));
            break;
        }
        default:
            return;
    }
    //Assign children if finding is associated with dbOrder
    // const dbOrder = ModuleFE_Advisor_Action.cache.find(order => order.type === 'order' && order.variableId === f.variableId);
    // if (dbOrder) {
    //
    // }
    return findingToUpdate;
}
//Conversion - Normalize EMFindings
function normalize_EMFindings(emFindings) {
    const toRet = {
        findingsToUpdate: emFindings.findingsToUpdate.filter(ftu => {
            switch (ftu.type) {
                case 'enumerated':
                    return !!ftu.valueIds?.length;
                case 'numeric':
                    return exists(ftu.value);
            }
        }),
        processedRawFindings: emFindings.processedRawFindings.filter(prf => {
            switch (prf.type) {
                case 'enumerated':
                    return !!prf.valueIds?.length;
                case 'numeric':
                    return exists(prf.value);
            }
        })
    };
    //Filter attributes
    [...toRet.findingsToUpdate, ...toRet.processedRawFindings].forEach(item => {
        if (item.type !== 'enumerated')
            return;
        item.attributes = item.attributes?.filter(att => exists(att.valueIds?.[0]));
    });
    return toRet;
}
export const AdvisorConversion = {
    finding_findingToUpdate: convert_Finding_FindingToUpdate,
    normalize_EMFindings: normalize_EMFindings,
};
//# sourceMappingURL=advisor-conversion.js.map